import Footer from "../components/footer";
import Header from "../components/header";
import PageHeader from "../components/pageHeader";
import SideNav from "../components/sidenav";
import DataTable from "react-data-table-component";
import React, { useState, useEffect, useRef, useCallback } from "react";
import {useParams, NavLink} from   "react-router-dom";


const ViewArtworkDetails=()=>{

    const { id } = useParams();
    const [productImages, setProductImages] = useState([]);
    const [subjects, setSubjects] = useState([]);
    const [styles, setStyles] = useState([]);

    const [productDetails, setProductDetails] = useState({
        productTitle: '', ownerName: '', artistName: '', category: '', description: '', price: '',
        originalPainting: '', newArrival: '', eliteChoice: '', affordableArt: '', priceOnDemand: '',
        negotiable: '', printingRights: '', featured: '', refundable: '', certificate: '', 
        medium: '', surface: '', orientation: '', size: '', commission: '', packingMode: '',  
        shippingTime: '', created_in: '', remark_to_indigalleria: '', remark_to_artist: '', tags: '',
        statusName: '', lockStatus: '', inventoryStatus: '', CreatedOn: '', status:0, is_lock:0
        
        // Additional fields as needed
    });

    // Function to Fetch data from API for dropdown
    const fetchData = useCallback(async (url, setData) => {
        debugger;
        try {
            const response = await fetch(url);
            if (!response.ok) {
                throw new Error('Failed to fetch data');
            }
            const data = await response.json();
            setData(data);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }, []);

    useEffect(() => {
        if (id) {
            debugger;
            fetchData(`https://igapi.heuristticminds.com/api/ProductList/Get-GetArtworkDetailsToViewByProductID?id=${id}`, setProductDetails);
            fetchData(`https://igapi.heuristticminds.com/api/ProductList/Get-GetArtworkImagesByProductID?id=${id}`, setProductImages);
            fetchData(`https://igapi.heuristticminds.com/api/SubjectStyleList/Get-GetProductSubjectListByProductID?id=${id}`, setSubjects);
            fetchData(`https://igapi.heuristticminds.com/api/SubjectStyleList/Get-GetProductStyleListByProductID?id=${id}`, setStyles);
            
        }
    }, [id, fetchData]);


    return(
        <>
            <Header />
            <div id="layoutSidenav">
                <SideNav />
                <div id="layoutSidenav_content">

                    <PageHeader name='Artwork Details' icon='bi bi-activity' />
                    {productDetails ? (
                    <div className="container-xl px-4">
                        <div className="row">
                            <div className="col-lg-12 mb-4">
                                <div className="card mb-4">
                                    <div className="card-header">Artwork Details</div>
                                    <div className="card-body">
                                    {!(productDetails.is_lock === 2 || (productDetails.is_lock !== 2 && (productDetails.status === 2 || productDetails.status === 3 || productDetails.status === 5))) && (
                                        <NavLink className="btn btn-primary float-end" to={`/addArtwork/${id}`}>
                                        <i className="bi bi-pencil-square"></i> Edit
                                        </NavLink>
                                    )}
                                        <NavLink className="btn btn-primary float-end" to={'/artworkAll'} style={{ marginRight: '10px' }}><i className="bi bi-arrow-return-left"></i> Back</NavLink>
                                        <div className="clearfix"></div>
                                        <form>
                                        <div className="p-4 pt-2">  
                                                <div className="row">
                                                    
                                                        <div className="col-sm-6 form-group mb-3">
                                                            <h5>
                                                            <label style={{ marginRight: '10px', fontWeight: 'bold' }}>Artwork Title : </label>
                                                            <label>{productDetails.productTitle}</label>  
                                                            </h5>
                                                        </div>
                                                        <div className="col-sm-6 form-group mb-3">
                                                            <h5>
                                                            <label style={{ marginRight: '10px', fontWeight: 'bold' }}>Artwork ID : </label>
                                                            <label> IG{productDetails.id}</label>  
                                                            </h5>
                                                        </div>
                                                    
                                                </div>
                                                <div className="row">
                                                    
                                                        <div className="col-sm-6 form-group mb-3">
                                                            <h5>
                                                            <label style={{ marginRight: '10px', fontWeight: 'bold' }}>Artist : </label>
                                                            <label> {productDetails.artistName}</label>  
                                                            </h5>
                                                        </div>
                                                        <div className="col-sm-6 form-group mb-3">
                                                            <h5>
                                                            <label style={{ marginRight: '10px', fontWeight: 'bold' }}>Owner : </label>
                                                            <label> {productDetails.ownerName}</label>  
                                                            </h5>
                                                        </div>
                                                    
                                                </div>
                                                
                                                <div className="row">
                                                    <h4>
                                                          
                                                    </h4>
                                                </div>
                                                
                                                
                                                <div className="row">
                                                    <div className="col-sm-6 form-group mb-3">
                                                        <label style={{ marginRight: '10px', fontWeight: 'bold' }}>Category : </label>
                                                        <label>{productDetails.category}</label>
                                                    </div>     
                                                    <div className="col-sm-6 form-group mb-3">
                                                        <label style={{ marginRight: '10px', fontWeight: 'bold' }}>Price : </label>
                                                        <label>{productDetails.price}</label>  
                                                    </div>   
                                                </div>
                                                <div className="row">
                                                    <div className="col-sm-6 form-group mb-3">
                                                        <label style={{ marginRight: '10px', fontWeight: 'bold' }}>Medium : </label>
                                                        <label>{productDetails.medium}</label>  
                                                    </div>                                         

                                                    <div className="col-sm-6 form-group mb-3">
                                                        <label style={{ marginRight: '10px', fontWeight: 'bold' }}>Surface : </label>
                                                        <label>{productDetails.surface}</label>  
                                                    </div>                                         
                                                </div>
                                                <div className="row">
                                                <div className="col-sm-6 form-group mb-3">
                                                        <label style={{ marginRight: '10px', fontWeight: 'bold' }}>New Arrival : </label>
                                                        <label>{productDetails.newArrival}</label>                                                       

                                                    </div>
                                                    <div className="col-sm-6 form-group mb-3">
                                                        <label style={{ marginRight: '10px', fontWeight: 'bold' }}>Original Painting : </label>
                                                        <label>{productDetails.originalPainting}</label>                                                       

                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-sm-3 form-group mb-3">
                                                        <label style={{ marginRight: '10px', fontWeight: 'bold' }}>Elite Choice :</label>
                                                        <label>{productDetails.eliteChoice}</label>                                                         

                                                    </div>
                                                    <div className="col-sm-3 form-group mb-3">
                                                        <label style={{ marginRight: '10px', fontWeight: 'bold' }}>Affordable Art :</label>
                                                        <label>{productDetails.affordableArt}</label>                                                      

                                                    </div>
                                                    <div className="col-sm-3 form-group mb-3">
                                                        <label style={{ marginRight: '10px', fontWeight: 'bold' }}>Price On Demand :</label>
                                                        <label>{productDetails.priceOnDemand}</label>                               

                                                    </div>
                                                    <div className="col-sm-3 form-group mb-3">
                                                        <label style={{ marginRight: '10px', fontWeight: 'bold' }}>Negotiable :</label>
                                                        <label>{productDetails.negotiable}</label>                                                     

                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-sm-3 form-group mb-3">
                                                        <label style={{ marginRight: '10px', fontWeight: 'bold' }}>Featured :</label>
                                                        <label>{productDetails.featured}</label>                                                    

                                                    </div>
                                                    <div className="col-sm-3 form-group mb-3">
                                                        <label style={{ marginRight: '10px', fontWeight: 'bold' }}>Printing Rights :</label>
                                                        <label>{productDetails.printingRights}</label>                                                

                                                    </div>

                                                    <div className="col-sm-3 form-group mb-3">
                                                        <label style={{ marginRight: '10px', fontWeight: 'bold' }}>Certificate :</label>
                                                        <label>{productDetails.certificate}</label>                                                   

                                                    </div>
                                                    <div className="col-sm-3 form-group mb-3">
                                                        <label style={{ marginRight: '10px', fontWeight: 'bold' }}>Refundable :</label>
                                                        <label>{productDetails.refundable}</label>                                             

                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-sm-6 form-group mb-3">
                                                        <label style={{ marginRight: '10px', fontWeight: 'bold' }}>Oriantation :</label>
                                                        <label>{productDetails.orientation}</label>                                                  

                                                    </div>
                                                    <div className="col-sm-6 form-group mb-3">
                                                        <label style={{ marginRight: '10px', fontWeight: 'bold' }}>Size :</label>
                                                        <label>{productDetails.size}</label>                                                                                                     

                                                    </div>
                                                    
                                                </div>
                                                <div className="row">
                                                    <div className="col-sm-6 form-group mb-3">
                                                        <label style={{ marginRight: '10px', fontWeight: 'bold' }}>Commission :</label>
                                                        <label>{productDetails.commission}</label> 

                                                    </div>
                                                    <div className="col-sm-6 form-group mb-3">
                                                        <label style={{ marginRight: '10px', fontWeight: 'bold' }}>Creation Year :</label>
                                                        <label>{productDetails.created_in}</label> 

                                                    </div>
                                                    
                                                </div>
                                                <div className="row">
                                                    <div className="col-sm-6 form-group mb-3">
                                                        <label style={{ marginRight: '10px', fontWeight: 'bold' }}>Packing Mode : </label>
                                                        <label>{productDetails.packingMode}</label> 
                                                    </div>
                                                    <div className="col-sm-6 form-group mb-3">
                                                        <label style={{ marginRight: '10px', fontWeight: 'bold' }}>Shipping Time : </label>
                                                        <label>{productDetails.shippingTime}</label> 
                                                    </div>
                                                </div>
                                                <div className="row">
                                                <div className="col-sm-6 form-group mb-3">
                                                        <label style={{ marginRight: '10px', fontWeight: 'bold' }}>Description : </label>
                                                        <div style={{ whiteSpace: "pre-line", width: "1350px" }}><label dangerouslySetInnerHTML={{ __html: productDetails.description }}/></div>
                                                    </div>  
                                                </div>
                                                <div className="row">
                                                        <div className="col-sm-6 form-group mb-3">
                                                            <label style={{ marginRight: '10px', fontWeight: 'bold' }}>Subjects:</label>
                                                            <ul>
                                                                {subjects.map(subjectList => (
                                                                    <li key={subjectList.id}>{subjectList.subject}</li>
                                                                ))}
                                                            </ul>
                                                        </div>
                                                        <div className="col-sm-6 form-group mb-3">
                                                            <label style={{ marginRight: '10px', fontWeight: 'bold' }}>Styles:</label>
                                                            <ul>
                                                                {styles.map(styleList => (
                                                                    <li key={styleList.id}>{styleList.style}</li>
                                                                ))}
                                                            </ul>
                                                        </div>
                                                    </div>
                                                
                                                
                                        </div>
                                                <div className="p-4 pt-2">  
                                                    <div className="horizontal-image-list">
                                                        {productImages.map((imageList, index) => (
                                                            <img key={index} src={`../images/products/full/${imageList.image}`} alt={`Image ${index}`} />
                                                        ))}
                                                    </div>
                                                    
                                                </div>
                                        </form>
                                    </div>




                                </div>

                            </div>
                        </div>
                    </div>
                    

                    
                    
                    ): (
                        // Render a loading indicator or some placeholder while waiting for data
                        <div>Loading...</div>
                    )}

                    <Footer />
                </div>
            </div>
        </>
    )

};
export default ViewArtworkDetails